@if (!dsParseError()) {
<div class="data-source-viewer">
  <ng-template #csvSeparator let-sep="separatorType" let-custom="customSeparator">
    {{ sep === 'comma' ? ('data-source.common.separator.comma' | translate) : sep === 'semicolon' ?
    ('data-source.common.separator.semicolon' | translate) : sep === 'colon' ? ('data-source.common.separator.colon' |
    translate) : sep === 'space' ? ('data-source.common.separator.space' | translate) : sep === 'tab' ?
    ('data-source.common.separator.tab' | translate) : custom }}
  </ng-template>
  <!-- Общая информация -->
  <div class="section">
    <h3>{{ 'data-source-form-viewer.general-info' | translate }}</h3>
    <div class="field-group">
      <div class="field-group-item">
        <label>{{ 'data-source.common.unique-name' | translate }}:</label>
        <span>{{ parsedDs()?.params?.name || ('common.not-specified' | translate) }}</span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source-list.table.columns.owner-name' | translate }}:</label>
        <span>{{ parsedDs()?.ownerName || ('common.not-specified' | translate) }}</span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source-list.table.columns.created' | translate }}:</label>
        <span>{{ parsedDs()?.creationDateTime | date: 'dd.MM.yyyy HH:mm' }}</span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source-form-viewer.access-level' | translate }}:</label>
        <span
          class="access-level"
          [class.write]="parsedDs()?.accessLevel === 'write' || parsedDs()?.accessLevel === 'writeRead'"
        >
          {{ parsedDs()?.accessLevel === 'write' ? ('data-source-form-viewer.access-level.write' | translate) :
          parsedDs()?.accessLevel === 'writeRead' ? ('data-source-form-viewer.access-level.read-write' | translate) :
          ('data-source-form-viewer.access-level.read' | translate) }}
        </span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source-list.table.columns.visibility' | translate }}:</label>
        <span>
          {{ parsedDs()?.params?.visibility === 'publicVisibility' ? ('data-source.common.visibility.public' |
          translate) : ('data-source-form-viewer.visibility.private' | translate) }}
        </span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source-list.table.columns.type' | translate }}:</label>
        <span>{{ getDataSourceTypeTranslationKey(parsedDs()?.params?.datasourceType) | translate }}</span>
      </div>
    </div>
  </div>

  <!-- Библиотечные файлы -->
  @if (parsedDs()?.params?.libraryFileParams) {
  <div class="section">
    <h3>{{ 'data-source-list.toolbar.actions.create.library' | translate }}</h3>
    <div class="field-group">
      <div class="field-group-item">
        <label>{{ 'data-source.library.source' | translate }}:</label>
        <span>{{ parsedDs()?.params?.libraryFileParams?.libraryPath }}</span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.common.label.format' | translate }}:</label>
        <span>{{ parsedDs()?.params?.libraryFileParams?.fileFormat?.toUpperCase() }}</span>
      </div>
      @if (parsedDs()?.params?.libraryFileParams?.csvFileFormatParams) {
      <div class="csv-params">
        <h4>{{ 'data-source-form-viewer.csv-params' | translate }}</h4>
        <div class="field-group-item">
          <label>{{ 'data-source.common.checkbox.first-row-header' | translate }}:</label>
          <span>
            {{ parsedDs()?.params?.libraryFileParams?.csvFileFormatParams?.includeHeader ? ('common.yes' | translate) :
            ('common.no' | translate) }}
          </span>
        </div>
        <div class="field-group-item">
          <label>{{ 'data-source.common.checkbox.convert-boolean' | translate }}:</label>
          <span>
            {{ parsedDs()?.params?.libraryFileParams?.csvFileFormatParams?.convert01ToBoolean ? ('common.yes' |
            translate) : ('common.no' | translate) }}
          </span>
        </div>
        <div class="field-group-item">
          <label>{{ 'data-source.library.separator' | translate }}:</label>
          <span>
            <ng-container
              [ngTemplateOutlet]="csvSeparator"
              [ngTemplateOutletContext]="{
                separatorType: parsedDs()?.params?.libraryFileParams?.csvFileFormatParams?.separatorType,
                customSeparator: parsedDs()?.params?.libraryFileParams?.csvFileFormatParams?.customSeparator
              }"
            ></ng-container>
          </span>
        </div>
      </div>
      }
    </div>
  </div>
  }

  <!-- S3 параметры -->
  @if (parsedDs()?.params?.s3Params) {
  <div class="section">
    <h3>{{ 'data-source-list.toolbar.actions.create.s3' | translate }}</h3>
    <div class="field-group">
      <div class="field-group-item">
        <label>{{ 'data-source.s3.label.endpoint' | translate }}:</label>
        <span>{{ parsedDs()?.params?.s3Params?.endpoint }}</span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.s3.label.access-key' | translate }}:</label>
        <span>{{ maskSensitiveData(parsedDs()?.params?.s3Params?.accessKey) }}</span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.s3.label.secret-key' | translate }}:</label>
        <span>{{ maskSensitiveData(parsedDs()?.params?.s3Params?.secretKey) }}</span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.s3.label.bucket' | translate }}:</label>
        <span>{{ parsedDs()?.params?.s3Params?.bucket }}</span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.s3.label.pattern' | translate }}:</label>
        <span>{{ parsedDs()?.params?.s3Params?.pattern }}</span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.common.checkbox.disable-ssl' | translate }}:</label>
        <span>
          {{ parsedDs()?.params?.s3Params?.withoutSSL ? ('common.yes' | translate) : ('common.no' | translate) }}
        </span>
      </div>
    </div>
  </div>
  }

  <!-- Kafka параметры -->
  @if (parsedDs()?.params?.kafkaParams) {
  <div class="section">
    <h3>{{ 'data-source-list.toolbar.actions.create.kafka' | translate }}</h3>
    <div class="field-group">
      <div class="field-group-item">
        <label>{{ 'data-source.kafka.label.brokers' | translate }}:</label>
        <span>{{ parsedDs()?.params?.kafkaParams?.brokers }}</span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.kafka.label.topic' | translate }}:</label>
        <span>{{ parsedDs()?.params?.kafkaParams?.topic }}</span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.common.checkbox.ssl-enabled' | translate }}:</label>
        <span>
          {{ parsedDs()?.params?.kafkaParams?.sslEnabled ? ('common.yes' | translate) : ('common.no' | translate) }}
        </span>
      </div>
    </div>
  </div>
  }

  <!-- HDFS параметры -->
  @if (parsedDs()?.params?.hdfsParams) {
  <div class="section">
    <h3>{{ 'data-source-list.toolbar.actions.create.hd' | translate }}</h3>
    <div class="field-group">
      <div class="field-group-item">
        <label>{{ 'data-source.hdfs.label.hdfs-path' | translate }}:</label>
        <span>{{ parsedDs()?.params?.hdfsParams?.hdfsPath }}</span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.common.label.format' | translate }}:</label>
        <span>{{ parsedDs()?.params?.hdfsParams?.fileFormat }}</span>
      </div>
      @if (parsedDs()?.params?.hdfsParams?.csvFileFormatParams) {
      <div class="csv-params">
        <h4>{{ 'data-source-form-viewer.csv-params' | translate }}</h4>
        <div class="field-group-item">
          <label>{{ 'data-source.common.checkbox.first-row-header' | translate }}:</label>
          <span>
            {{ parsedDs()?.params?.hdfsParams?.csvFileFormatParams?.includeHeader ? ('common.yes' | translate) :
            ('common.no' | translate) }}
          </span>
        </div>
        <div class="field-group-item">
          <label>{{ 'data-source.common.checkbox.convert-boolean' | translate }}:</label>
          <span>
            {{ parsedDs()?.params?.hdfsParams?.csvFileFormatParams?.convert01ToBoolean ? ('common.yes' | translate) :
            ('common.no' | translate) }}
          </span>
        </div>
        <div class="field-group-item">
          <label>{{ 'data-source.library.separator' | translate }}:</label>
          <span>
            <ng-container
              [ngTemplateOutlet]="csvSeparator"
              [ngTemplateOutletContext]="{
                separatorType: parsedDs()?.params?.hdfsParams?.csvFileFormatParams?.separatorType,
                customSeparator: parsedDs()?.params?.hdfsParams?.csvFileFormatParams?.customSeparator
              }"
            ></ng-container>
          </span>
        </div>
      </div>
      }
    </div>
  </div>
  }

  <!-- Google Spreadsheet параметры -->
  @if (parsedDs()?.params?.googleSpreadsheetParams) {
  <div class="section">
    <h3>{{ 'data-source-list.toolbar.actions.create.google-spreadsheet' | translate }}</h3>
    <div class="field-group">
      <div class="field-group-item">
        <label>{{ 'data-source.google-spreadsheet.label.spreadsheet-id' | translate }}:</label>
        <span>{{ parsedDs()?.params?.googleSpreadsheetParams?.googleSpreadsheetId }}</span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.google-spreadsheet.label.service-account-credentials' | translate }}:</label>
        <span>
          {{ maskSensitiveData(parsedDs()?.params?.googleSpreadsheetParams?.googleServiceAccountCredentials) }}
        </span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.common.checkbox.first-row-header' | translate }}:</label>
        <span>
          {{ parsedDs()?.params?.googleSpreadsheetParams?.includeHeader ? ('common.yes' | translate) : ('common.no' |
          translate) }}
        </span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.common.checkbox.convert-boolean' | translate }}:</label>
        <span>
          {{ parsedDs()?.params?.googleSpreadsheetParams?.convert01ToBoolean ? ('common.yes' | translate) : ('common.no'
          | translate) }}
        </span>
      </div>
    </div>
  </div>
  }

  <!-- Внешние файлы -->
  @if (parsedDs()?.params?.externalFileParams) {
  <div class="section">
    <h3>{{ 'data-source-list.toolbar.actions.create.external-file' | translate }}</h3>
    <div class="field-group">
      <div class="field-group-item">
        <label>{{ 'data-source.file.label.source-url' | translate }}:</label>
        <span>{{ parsedDs()?.params?.externalFileParams?.url }}</span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.common.label.format' | translate }}:</label>
        <span>{{ parsedDs()?.params?.externalFileParams?.fileFormat?.toUpperCase() }}</span>
      </div>
      @if (parsedDs()?.params?.externalFileParams?.csvFileFormatParams) {
      <div class="csv-params">
        <h4>{{ 'data-source-form-viewer.csv-params' | translate }}</h4>
        <div class="field-group-item">
          <label>{{ 'data-source.common.checkbox.first-row-header' | translate }}:</label>
          <span>
            {{ parsedDs()?.params?.externalFileParams?.csvFileFormatParams?.includeHeader ? ('common.yes' | translate) :
            ('common.no' | translate) }}
          </span>
        </div>
        <div class="field-group-item">
          <label>{{ 'data-source.common.checkbox.convert-boolean' | translate }}:</label>
          <span>
            {{ parsedDs()?.params?.externalFileParams?.csvFileFormatParams?.convert01ToBoolean ? ('common.yes' |
            translate) : ('common.no' | translate) }}
          </span>
        </div>
        <div class="field-group-item">
          <label>{{ 'data-source.library.separator' | translate }}:</label>
          <span>
            <ng-container
              [ngTemplateOutlet]="csvSeparator"
              [ngTemplateOutletContext]="{
                separatorType: parsedDs()?.params?.externalFileParams?.csvFileFormatParams?.separatorType,
                customSeparator: parsedDs()?.params?.externalFileParams?.csvFileFormatParams?.customSeparator
              }"
            ></ng-container>
          </span>
        </div>
      </div>
      }
    </div>
  </div>
  }

  <!-- JDBC параметры -->
  @if (parsedDs()?.params?.jdbcParams) {
  <div class="section">
    <h3>{{ 'data-source-list.toolbar.actions.create.database' | translate }}</h3>
    <div class="field-group">
      <div class="field-group-item">
        <label>{{ 'data-source.db.label.driver' | translate }}:</label>
        <span>{{ parsedDs()?.params?.jdbcParams?.driver }}</span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.db.label.jdbc-connection' | translate }}:</label>
        <span>{{ parsedDs()?.params?.jdbcParams?.url }}</span>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.common.category.query' | translate }}:</label>
        <pre class="query-text">{{ parsedDs()?.params?.jdbcParams?.query }}</pre>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.common.label.table-name' | translate }}:</label>
        <span>{{ parsedDs()?.params?.jdbcParams?.table }}</span>
      </div>
    </div>
  </div>
  }

  <!-- Hive параметры -->
  @if (parsedDs()?.params?.hiveParams) {
  <div class="section">
    <h3>{{ 'data-source-list.toolbar.actions.create.hive' | translate }}</h3>
    <div class="field-group">
      <div class="field-group-item">
        <label>{{ 'data-source.common.category.query' | translate }}:</label>
        <pre class="query-text">{{ parsedDs()?.params?.hiveParams?.query }}</pre>
      </div>
      <div class="field-group-item">
        <label>{{ 'data-source.common.label.table-name' | translate }}:</label>
        <span>{{ parsedDs()?.params?.hiveParams?.table }}</span>
      </div>
    </div>
  </div>
  }

  <!-- Дополнительные свойства -->
  @if (parsedDs()?.params?.properties) {
  <div class="section">
    <h3>{{ 'data-source.common.additional-parameters' | translate }}</h3>
    <pre class="properties-text">{{ parsedDs()?.params?.properties }}</pre>
  </div>
  }
</div>
} @else {
<div class="error-message">
  <h3>{{ 'data-source-form-viewer.parse-error' | translate }}</h3>
  <p>{{ dsParseErrorText() }}</p>
</div>
}
